
import { db } from '@/integrations/neon/db';

/**
 * Increments research_generations by 1 for the given user.
 * If no statistics row exists, creates one.
 * @param userId string (uuid)
 */
export const incrementResearchGenerations = async (userId: string) => {
  if (!userId) return;

  // Find existing row
  const { data: stats, error } = await db
    .from("statistics")
    .select("id, research_generations")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.error("Error fetching statistics row (research_generations):", error);
    return;
  }

  if (stats && stats.id) {
    // Update: increment the counter
    const incValue =
      typeof stats.research_generations === "number"
        ? stats.research_generations + 1
        : 1;
    const { error: updateError } = await db
      .from("statistics")
      .update({
        research_generations: incValue,
        updated_at: new Date().toISOString(),
      })
      .eq("id", stats.id);

    if (updateError) {
      console.error("Error updating research_generations:", updateError);
    }
  } else {
    // Insert: no row exists, create it
    const { error: insertError } = await db
      .from("statistics")
      .insert([
        {
          user_id: userId,
          research_generations: 1,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
      ]);
    if (insertError) {
      console.error("Error inserting research_generations row:", insertError);
    }
  }
};
